<template>
  <nav class="gnb">
    <!-- [D] 로그인 전 노출되는 영역 -->
    <div class="top_wrap" v-if="enableUserMenu && isEmpty(session.uuid)">
      <a :href="getToastIdUrl('login')" class="btn_login">{{ $t('gnb.signin') }}</a>
      <button type="button" :class="showGnb ? 'btn_gnb_close' : 'showGnb'"
        @click="setShowGnb(!showGnb)">{{ $t('gnb.toggle-show-gnb') }}</button>
    </div>
    <!-- [D] 로그인 전 노출되는 영역 -->
    <!-- [D] 로그인 시 노출되는 영역 -->
    <div class="top_wrap" v-if="enableUserMenu && exist(session.uuid)">
      <span class="member_id">{{session.maskedEmail}}</span>
      <a :href="getToastIdUrl('logout')" class="btn_logout">{{ $t('gnb.signout') }}</a>
      <button type="button" :class="showGnb ? 'btn_gnb_close' : 'showGnb'"
        @click="setShowGnb(!showGnb)">{{ $t('gnb.toggle-show-gnb') }}</button>
    </div>
    <!-- [D] 로그인 시 노출되는 영역 -->
    <div class="gnb_scroll_wrap">
      <ul class="lst_gnb">
        <li class="gnb_menu is_m_show" :class="{is_point: gnbMenu.type == 'button', has_left_gap: exist(gnbMenu.rightSideMenuComopnent)}"
          v-for="(gnbMenu, gnbMenuNo) in gnbMenusOnlyShow" :key="gnbMenu.content"
          @mouseover="hoverCustomMenu(gnbMenu, true)"
          @mouseout="hoverCustomMenu(gnbMenu, false)">
          <!-- 단일 메뉴 -->
          <template v-if="!exist(gnbMenu.subMenus) && !exist(gnbMenu.subMenuComponent)">
            <router-link-ex :condition="!gnbMenu.isExternal" :to="getGnbMenuUrl(gnbMenu)" class="link_menu"
              :class="{ 'is_hover': gnbMenu.hover, is_m_show: !exist(gnbMenu.rightSideMenuComopnent) }" active-class="is_selected"
              :target="gnbMenu.isBlank ? '_blank' : '_self'">
              <span class="menu_txt">
                {{ isEmpty(gnbMenu.messageId) ? gnbMenu.content : $t(gnbMenu.messageId) }}
                <span class="ico_link" v-if="gnbMenu.showIcoLink">바로 가기</span>
              </span>
            </router-link-ex>
            <component v-if="exist(gnbMenu.rightSideMenuComopnent)" :is="gnbMenu.rightSideMenuComopnent"></component>
          </template>

          <!-- 하위 메뉴 있을 경우 -->
          <a v-else @click="gnbMenu.showCollapse = !gnbMenu.showCollapse" :class="{ collapsed: !gnbMenu.showCollapse }"
            :aria-controls="`gnb_menu_collapse_${gnbMenuNo}`" :aria-expanded="gnbMenu.showCollapse ? 'true' : 'false'"
            data-toggle="collapse" class="link_menu is_m_show"><span class="menu_txt">{{
              isEmpty(gnbMenu.messageId) ? gnbMenu.content : $t(gnbMenu.messageId) }}</span></a>
          <b-collapse v-model="gnbMenu.showCollapse" :id="`gnb_menu_collapse_${gnbMenuNo}`" class="drop_menu_wrap"
            v-if="exist(gnbMenu.subMenus) || exist(gnbMenu.subMenuComponent)" @mouseover="hoverCustomMenu(gnbMenu, true)"
            @mouseout="hoverCustomMenu(gnbMenu, false)">
            <ul class="lst_gnb_sub" v-if="exist(gnbMenu.subMenus)">
              <li class="gnb_sub_menu" v-for="subMenu in subMenusNotPc(gnbMenu.subMenus)" :key="subMenu.content" v-if="isGnbSubMenuPartShow(subMenu)">
                <router-link-ex :to="addCountryIfHomepageUrl(subMenu.url)" class="menu_txt" @click.native="hoverCustomMenu(gnbMenu, false)"
                                :condition="!subMenu.isExternal" :target="subMenu.isBlank ? '_blank' : '_self'">
                  {{ isEmpty(subMenu.messageId) ? subMenu.content : $t(subMenu.messageId) }}
                </router-link-ex>
              </li>
            </ul>
            <component :is="gnbMenu.subMenuComponent" v-if="exist(gnbMenu.subMenuComponent)" @close="hoverCustomMenu(gnbMenu, false)" />
          </b-collapse>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { from } from 'rxjs'
import { mapState, mapMutations } from 'vuex'
import { isEmpty, filter, includes } from 'lodash-es'
import 'bootstrap/js/dist/collapse'
import { BCollapse } from 'bootstrap-vue'

import { namespace } from '../../../store/modules/session-store'
import { namespace as commonNamespace } from '../../../store/modules/common-store'
import { namespace as gnbNamespace, types as gnbTypes } from '../../../store/modules/gnb-store'

import GnbHeaderMenuCommon from './GnbHeaderMenuCommon'

export default {
  mixins: [GnbHeaderMenuCommon],
  props: {
    enableUserMenu: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    $route() {
      this.setShowGnb(false)
      from(this.gnbMenus).subscribe(gnbMenu => (gnbMenu.showCollapse = false))
    }
  },
  methods: {
    ...mapMutations(gnbNamespace, [gnbTypes.SET_SHOW_GNB]),
    isEmpty: isEmpty,
    subMenusNotPc(subMenus) {
      return filter(subMenus, subMenu => subMenu.display !== 'PC')
    },
    isSubMenusShow(subMenu) {
      if (this.isJp && includes(subMenu.hide, 'JP')) return false
      if (!this.isJp && includes(subMenu.hide, 'KR')) return false
      return true
    },
    getGnbMenuUrl(gnbMenu) {
      const url = this.isJp && !!gnbMenu.content && gnbMenu.content === 'Meetup' ? domain['meetup-jp'] : gnbMenu.url
      return this.addCountryIfHomepageUrl(url)
    }
  },
  computed: {
    ...mapState(namespace, ['session']),
    ...mapState(gnbNamespace, ['showGnb']),
    ...mapState(commonNamespace, ['isMobile']),
    gnbMenusOnlyShow() {
      return filter(this.gnbMenus, gnbMenu => this.isGnbMenuShow(gnbMenu))
    }
  },
  components: { BCollapse }
}
</script>
